(() => {
  if (window.HSQuickAdd) return;
  const dialog = document.querySelector('[data-hs-quick-add]');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const find = selector => dialog.querySelector(selector);
  const content = find('[data-quick-add-content]');
  const status = find('[data-quick-add-status]');
  const error = find('[data-quick-add-error]');
  const form = find('[data-hs-quick-add-form]');
  const fields = find('[data-quick-add-options]');
  const input = find('[data-quick-add-id]');
  const submit = find('[data-quick-add-submit]');
  const price = find('[data-quick-add-price]');
  const compare = find('[data-quick-add-compare]');
  const selection = find('[data-quick-add-selection]');
  const image = find('[data-quick-add-image]');
  const imageLink = find('[data-quick-add-image-link]');
  const details = find('[data-quick-add-details]');
  const currency = window.Shopify?.currency?.active || dialog.dataset.currency || 'USD';
  const imageSource = source => {
    const url = new URL(source, location.origin);
    url.searchParams.set('width', '600');
    return url.href;
  };
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style: 'currency', currency}).format(cents / 100);
  let product;
  let opener;
  let controller;
  let loading = false;
  let selectedVariant;

  const setButtonLabel = text => { submit.textContent = text; };
  const productPath = value => {
    const url = new URL(value, location.origin);
    if (url.origin !== location.origin || !/\/products\/[^/]+\/?$/.test(url.pathname)) throw new Error(dialog.dataset.error);
    url.search = ''; url.hash = '';
    url.pathname = url.pathname.replace(/\/$/, '');
    return url;
  };
  const update = () => {
    const selects = [...fields.querySelectorAll('select')];
    const chosen = selects.map(select => select.value);
    selects.forEach((select, position) => {
      [...select.options].forEach(option => {
        if (!option.value) return;
        option.disabled = !product.variants.some(variant => variant.available && variant.options[position] === option.value && chosen.every((value, index) => index >= position || !value || variant.options[index] === value));
      });
      if (select.selectedOptions[0]?.disabled && select.value) select.value = '';
      chosen[position] = select.value;
    });
    const complete = chosen.every(Boolean);
    selectedVariant = complete ? product.variants.find(variant => selects.length === 0 || variant.options.every((option, index) => option === chosen[index])) : null;
    const available = Boolean(selectedVariant?.available);
    input.value = available ? String(selectedVariant.id) : '';
    input.disabled = !available;
    submit.disabled = loading || !available;
    setButtonLabel(selectedVariant && !available ? dialog.dataset.soldLabel : dialog.dataset.addLabel);
    selection.textContent = selectedVariant ? selectedVariant.title === 'Default Title' ? '' : selectedVariant.title : dialog.dataset.chooseLabel;
    if (selectedVariant) {
      price.textContent = money(selectedVariant.price);
      compare.hidden = !(selectedVariant.compare_at_price > selectedVariant.price);
      compare.textContent = compare.hidden ? '' : money(selectedVariant.compare_at_price);
      const source = selectedVariant.featured_image?.src || selectedVariant.featured_image?.url || product.featured_image;
      if (source) { image.src = imageSource(source); image.hidden = false; }
    } else {
      price.textContent = product.price_min !== product.price_max ? `${money(product.price_min)} – ${money(product.price_max)}` : money(product.price);
      compare.hidden = true;
    }
    error.textContent = '';
  };
  const render = data => {
    product = data;
    find('[data-quick-add-title]').textContent = data.title;
    image.alt = data.title;
    image.hidden = !data.featured_image;
    if (data.featured_image) image.src = imageSource(data.featured_image);
    fields.replaceChildren();
    const onlyDefault = data.variants.length === 1 && data.variants[0].title === 'Default Title';
    if (!onlyDefault) {
      data.options.forEach((option, index) => {
        const optionName = typeof option === 'string' ? option : option.name;
        const values = [...new Set(data.variants.map(variant => variant.options[index]))];
        const field = document.createElement('fieldset');
        const label = document.createElement('label');
        const select = document.createElement('select');
        select.id = `HS-QuickAdd-Option-${index}`;
        select.required = true;
        label.htmlFor = select.id;
        label.textContent = optionName;
        const prompt = document.createElement('option');
        prompt.value = ''; prompt.textContent = dialog.dataset.chooseLabel; prompt.selected = true; prompt.disabled = true;
        select.append(prompt);
        values.forEach(value => { const item = document.createElement('option'); item.value = value; item.textContent = value; select.append(item); });
        field.append(label, select); fields.append(field);
      });
    }
    loading = false;
    update();
    status.textContent = data.variants.some(variant => variant.available) ? '' : dialog.dataset.soldLabel;
    content.hidden = false;
    fields.querySelector('select')?.focus({preventScroll: true});
  };
  const open = async button => {
    if (loading) return;
    opener = button;
    controller?.abort();
    controller = new AbortController();
    const request = controller;
    product = null; selectedVariant = null; input.value = ''; input.disabled = true;
    content.hidden = true; error.textContent = ''; status.textContent = dialog.dataset.loading; submit.disabled = true;
    let url;
    try { url = productPath(button.dataset.productUrl); }
    catch { status.textContent = dialog.dataset.error; return; }
    details.href = url.href; imageLink.href = url.href;
    document.querySelectorAll('dialog[open]').forEach(other => { if (other !== dialog) other.close(); });
    if (!dialog.open) dialog.showModal();
    try {
      url.pathname += '.js';
      const response = await fetch(url, {headers: {'Accept': 'application/json'}, credentials: 'same-origin', signal: request.signal});
      if (!response.ok) throw new Error(dialog.dataset.error);
      const data = await response.json();
      if (!data?.variants?.length || !Array.isArray(data.options)) throw new Error(dialog.dataset.error);
      if (request !== controller || !dialog.open) return;
      render(data);
    } catch (failure) {
      if (failure.name !== 'AbortError' && request === controller) { status.textContent = dialog.dataset.error; details.focus({preventScroll: true}); }
    }
  };
  const add = async () => {
    if (loading || !selectedVariant?.available || !form.reportValidity()) return;
    loading = true; submit.disabled = true; form.setAttribute('aria-busy', 'true'); error.textContent = ''; setButtonLabel(dialog.dataset.addingLabel);
    fields.querySelectorAll('select').forEach(select => { select.disabled = true; });
    try {
      if (window.HSCart && typeof window.HSCart.add === 'function') {
        await window.HSCart.add(form, opener);
        if (dialog.open) dialog.close();
      } else {
        const body = new FormData(form);
        const response = await fetch(dialog.dataset.addUrl + '.js', {method: 'POST', credentials: 'same-origin', headers: {'Accept': 'application/json'}, body});
        const result = await response.json();
        if (!response.ok || result.status >= 400) throw new Error(result.description || dialog.dataset.error);
        location.assign(dialog.dataset.cartUrl);
      }
    } catch (failure) {
      error.textContent = typeof failure.message === 'string' ? failure.message : dialog.dataset.error;
    } finally {
      loading = false; form.removeAttribute('aria-busy');
      fields.querySelectorAll('select').forEach(select => { select.disabled = false; });
      if (product) {
        const message = error.textContent;
        update(); error.textContent = message;
      }
    }
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-hs-quick-add-open]');
    if (button) { event.preventDefault(); open(button); }
  });
  fields.addEventListener('change', update);
  submit.addEventListener('click', add);
  form.addEventListener('submit', event => { event.preventDefault(); event.stopImmediatePropagation(); add(); });
  dialog.addEventListener('close', () => { controller?.abort(); opener?.isConnected && opener.focus({preventScroll: true}); });
  const enable = scope => {
    if (scope.matches?.('[data-hs-quick-add-open]')) scope.hidden = false;
    scope.querySelectorAll?.('[data-hs-quick-add-open]').forEach(button => { button.hidden = false; });
  };
  enable(document);
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => { if (node.nodeType === 1) enable(node); }))).observe(document.body, {childList: true, subtree: true});
  window.HSQuickAdd = {open, refresh: () => enable(document)};
})();
